import AIChat from '../components/ai/AIChat';

export default function AIChatPage() {
    return (
        <div className="h-full">
            <AIChat />
        </div>
    );
}